import { jsx as _jsx } from "react/jsx-runtime";
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { Button } from '../Button';
import { useSnackbar } from '../Snackbar';
import { CopyIcon } from '../icons';
import { useI18n } from '../I18n';
export const CopyButton = ({ onClick, text, title, successMessage, ...rest }) => {
    const i18n = useI18n();
    const { snackbar } = useSnackbar();
    const [_, copy] = useCopyToClipboard();
    return (_jsx(Button, { ...rest, icon: CopyIcon, onClick: async (event) => {
            await copy(text);
            snackbar(successMessage || i18n.t('copied_to_clipboard'));
            onClick?.(event);
        }, title: title || i18n.t('copy'), type: "button", variant: "tertiary" }));
};
//# sourceMappingURL=CopyButton.js.map